import * as React from "react";
import FooterSection from "../templates/footer";
import NavBar from "../templates/navbar";
import { Helmet } from "react-helmet";

// markup
const IndexPage = () => {
  return (
    <main>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="google" content="nositelinkssearchbox" />
        <title>Growlytics Privacy Policy</title>
        <link rel="canonical" href="/" />
      </Helmet>

      <NavBar></NavBar>

      <div className="privacyPolicyPage relative py-16 bg-white overflow-hidden">
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
          <div
            className="relative h-full text-lg max-w-prose mx-auto"
            aria-hidden="true"
          >
            <svg
              className="absolute top-12 left-full transform translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="74b3fd99-0a6f-4271-bef2-e80eeafdf357"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)"
              />
            </svg>
            <svg
              className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="f210dbf6-a58d-4871-961e-36d5016a0f49"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)"
              />
            </svg>
            <svg
              className="absolute bottom-12 left-full transform translate-x-32"
              width={404}
              height={384}
              fill="none"
              viewBox="0 0 404 384"
            >
              <defs>
                <pattern
                  id="d3eb07ae-5182-43e6-857d-35c643af9034"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={384}
                fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)"
              />
            </svg>
          </div>
        </div>
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto">
            <h1>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-primary-900 sm:text-4xl">
                Privacy Policy
              </span>
            </h1>
          </div>
          <div className="md:max-w-4xl mt-6 prose prose-indigo prose-lg text-gray-500 mx-auto">
            <p>
              This Privacy Policy describes the privacy practices of Growlytics
              Technologies Pvt Ltd. and its subsidiaries and affiliates
              (collectively, “Growlytics” or “us” or “we”).
            </p>
            <p>
              Growlytics provides marketing technology services to other
              businesses – our clients. To use our services, our clients share
              with us confidential information about their individual consumers,
              including contact details and shopping histories and other data.
              We analyze that information and develop and send communications to
              the consumers only at the direction of the client who provided the
              information, and only on that client’s behalf.
            </p>
            <p>
              This Privacy Policy applies to: The growlytics.in,
              app.growlytics.in and any other websites or online services owned
              by us. Our website and online services are designed for businesses
              and are not intended for personal, family or household use.
              Accordingly, we treat all personal information covered by this
              Privacy Policy, including information about any visitors to our
              website, as pertaining to individuals acting as business
              representatives, rather than in their personal capacity.
            </p>

            <div className="content-header">Information We collect</div>
            <p>
              The Company collects individually identifiable information
              (“Personal Information”) from individuals who visit the Site
              (“Site Visitors”) and individuals who register to use the Services
              (“Customers”).
            </p>
            <p>
              When expressing an interest in obtaining additional information
              about the Services or registering to use the Services, the Company
              requires you to provide the Company with personal contact
              information including, but not limited to, name, company name,
              address, phone number, and email address, as well as a user name
              and password (“Required Contact Information”). In addition, the
              Company may be given data about you, the organization you
              represent, or a third party, such as information the organization
              you represent provides to the Company when it registers with the
              Network.
            </p>
            <p>
              When purchasing the Services, the Company may require you to
              provide the Company with financial qualification and billing
              information including, but not limited to, billing name and
              address, and the number of employees within the organization that
              will be using the Services (“Billing Information”). Required
              Contact Information, Billing Information, and optional information
              about Customers are referred to collectively as “Data About
              Customers”.
            </p>
            <p>
              As you visit or navigate the Site, the Company may also collect
              information through the use of commonly-used information-gathering
              tools including, but not limited to, cookies and Web beacons (“Web
              Site Navigational Information”). Web Site Navigational Information
              includes standard information from your web browser (such as
              browser type and browser language), your Internet Protocol
              address, geolocation and the actions you take on the Site (such as
              pages viewed and links clicked).
            </p>
            <p>
              When a Customer uploads or creates a subscriber list or puts
              together a promotional campaign via the Services, the Company has
              access to any data contained in such an email distribution list
              and/or the information in such an email campaign.
            </p>
            <p>
              When a Customer sends messages through the Services, the Company
              always tracks who opened/viewed the message and who clicked on any
              of the hyperlinks included. This information is used to measure
              and report the performance of campaigns, and to improve the
              Services. The Company may obtain additional information about a
              Customer’s recipients from third-party service providers.
            </p>
            <p>
              The Company may obtain from such third party service providers
              information linked to the email address or other information
              contained in a Customer’s recipient list or campaign, such as a
              name, age and participation in social media websites.
            </p>
            <p>
              The Company does not record the names or email addresses of Site
              Visitors who do not register as Network users unless such users
              subscribe to receive information via electronic mail. To protect
              children’s personal information, the Company does not knowingly
              collect any personal information from persons under the age of
              sixteen (16) that can be used to specifically identify them and
              the Company does not permit persons under the age of sixteen (16)
              to use the Network.
            </p>
            <p>
              If you believe the Company might have any information from or
              about underage children, please contact the Company at
              connect@growlytics.in
            </p>
            <div className="content-header">
              Client's Customer and Campaign Data
            </div>
            <p>
              The Company ensures that all subscriber lists, message content and
              reports remain private and confidential. The Company may scan the
              content of your campaigns to ensure it complies with the Terms.
              The Company will not sell, rent, loan or invite external access to
              a customer’s contact lists. Nor will Company themselves use
              customer’s contact lists for any purpose.
            </p>
            <div className="content-header">Use of information collected</div>
            <p>
              The Company uses Data About Customers to perform the Services you
              request. For example, if you fill out a “Contact Me” Web form, the
              Company will use the information provided to contact you about
              your interest in the Services.
            </p>
            <p>
              The Company may also use Data About Customers for marketing
              purposes with your prior express consent. For example, the Company
              may use information you provide to contact you to further discuss
              your interest in the Services and to send you information
              regarding the Company, its affiliates, and its partners, such as
              information about promotions or events.
            </p>
            <p>
              The Company may use Data About Customers to send System Alert
              Messages to let you know about temporary or permanent changes to
              the Services or the Network including, but not limited to, planned
              outages, new features offered, version updates, point releases,
              major releases, abuse warnings, and changes to our Terms, Privacy
              Policy and other documents and agreements.
            </p>
            <p>
              The Company may use Data About Customers to help enforce
              compliance with the Terms, the Company’s Anti-Spam Policy and
              applicable law including, but not limited to, helping to create
              white lists and blacklists, to develop and test algorithms,
              heuristics and other methods and tools for detecting violations
              and to apply those methods and tools to the Services.
            </p>
            <p>
              The Company uses Data About Customers to provide customer support
              and obtain feedback.
            </p>
            <p>
              The Company uses Web Site Navigational Information to operate and
              improve the Network. The Company may also use Web Site
              Navigational Information alone or in combination with Data About
              Customers to provide personalized information about the Company
              and the Services. Company may use both Data About Customers and
              Web Site Navigational Information to enforce the Company’s
              policies, or to protect the Company’s rights and intellectual
              property or the rights of others using the Company’s Site or the
              Services.
            </p>
            <div className="content-header">
              Sharing of information collected
            </div>
            <p>
              The Company may share Data About Customers with the Company’s
              contracted service providers so that these service providers can
              provide services on the Company’s behalf. Company may also share
              Data About Customers with the Company’s service providers to
              ensure the quality of information provided; and the Company may
              share Data About Customers with third parties in aggregated and/or
              anonymized form. Unless described in this Privacy Policy, Company
              does not share, sell, rent, or trade any information with third
              parties for their marketing or promotional purposes.
            </p>
            <p>
              The Company uses RazorPay™ and Stripe™ as a payment intermediary
              service to receive payments and to manage credit card processing.
              Stripe is not permitted to store, retain, or use Billing
              Information except for the sole purpose of credit card processing
              on the Company’s behalf.
            </p>
            <p>
              The Company reserves the right to use or disclose any information
              provided if required by applicable law, if the Company reasonably
              believes that use or disclosure is necessary to protect or enforce
              the Company’s rights, if the Company reasonably believes use or
              disclosure is necessary to protect the safety of any person,
              and/or to comply with a judicial proceeding, court order, or legal
              process. Whenever your information is disclosed under this
              paragraph, the Company may also disclose such information on a
              non-aggregated, non-anonymous basis.
            </p>
            <p>
              The Company may share Data About Customers, or any other
              information to a third party in connection with a merger, sale, or
              acquisition, or a bankruptcy. Also, the Company may disclose your
              information to affiliated legal entities and businesses with whom
              the Company is under common corporate control. Again, when your
              information is disclosed under this paragraph, the Company may
              also disclose such information on a non-aggregated, non-anonymous
              basis.
            </p>
            <p>
              The Company may also share Data About Customers or any other
              information with its service providers, business partners,
              suppliers, sub-contractors or agents who perform services for it,
              as well as its professional advisers (including the Company’s
              lawyers, bankers, auditors and insurers), and analytics and search
              engine providers that assist the Company in the improvement and
              optimization of the Network.
            </p>
            <div className="content-header">Retention of Information</div>
            <p>
              Following termination or deactivation of your account with the
              Network, the Company may retain information, including profile
              information and any other Data About Customers, in order to comply
              with applicable law, prevent fraud, resolve disputes, troubleshoot
              problems, assist with any investigation, enforce its rights under
              its agreements with you, for backup, audit or regulatory purposes,
              and for other actions permitted by law.
            </p>
            <p>
              Otherwise the Company will only retain your personal data for as
              long as reasonably necessary to fulfill the purposes for which it
              originally collected such information. To determine the
              appropriate retention period for personal data, the Company
              considers the amount, nature and sensitivity of the personal data,
              the potential risk of harm from unauthorized use or disclosure of
              your personal data, the purposes for which the Company processes
              your personal data and whether the Company can achieve those
              purposes through other means, and the applicable legal,
              regulatory, tax, accounting or other requirements.
            </p>
            <div className="content-header">International Transfers</div>
            <p>
              From time to time, personal information the Company collects from
              data subjects in the European Economic Area (“EEA”) may be
              transferred to, stored, processed or accessed by, the Company and
              other entities who may be based outside of the EEA, for example,
              the United States. Also, the Company may allow its service
              providers or assistance providers, who may be located outside the
              EEA, to access your personal data. In addition, the Company may
              make other disclosures of your personal data outside the EEA, for
              example, in the event the Company receives a legal or regulatory
              request from a foreign law enforcement body.
            </p>
            <p>
              The Company will always take steps to ensure any transfer of such
              information to entities based outside the EEA is carefully managed
              to protect your rights and interests by implementing appropriate
              safeguards to protect your personal information. Your personal
              data may be transferred to countries that have been deemed to
              provide an adequate level of protection for personal data by the
              European Commission. To find out which countries are covered by
              this, please see here.
            </p>
            <p>
              Where there is no adequacy decision by the European Commission in
              respect of a country (to the extent that they are outside the
              EEA), which means it is not deemed to provide an adequate level of
              protection to your personal data, the Company will ensure your
              personal data receives an adequate level of protection. For
              example, each such transfer to a third party will be protected by
              contractual commitments and further assurances (where appropriate)
              such as the European Commission’s approved Standard Contractual
              Clauses.
            </p>
            <div className="content-header">
              Correcting and updating your information; Communications from the
              Company
            </div>
            <p>
              The Company does it’s best to keep Customers’ data accurate and
              up-to-date. If your data changes (including, but not limited to, a
              change in Customer’s email address) you are responsible for
              notifying the Company of those changes so that Company can keep
              your records up-to-date.
            </p>
            <p>
              If you receive one or more emails from the Company, it means one
              of two things: (i) your email address is on the Company’s list of
              customers or prospective customers; or (ii) you have provided the
              Company your email address so that it could contact you. If you
              believe you receive an email from the Company in error, please
              contact the Company immediately at connect@growlytics.in.
            </p>
            <p>
              The Company provides you with the opportunity to opt-out of
              receiving marketing communications from it at any point in time.
              If you wish to cease receiving marketing emails and other
              communications from the Company, you can opt-out by contacting the
              Company at connect@growlytics.in.
            </p>
            <p>
              In addition to the above rights of access, correction, amendment
              or deletion, if you live in the EEA, subject to applicable law,
              you may have some or all of the following rights with respect to
              your personal information:
              <ul className="list-disc ml-6 md:ml-10 mt-2">
                <li>
                  to restrict processing of your personal data if the data is
                  inaccurate, the processing is unlawful or the Company no
                  longer needs it for the purpose for which it holds it;
                </li>

                <li>
                  to transmit your data (as provided by you, directly or
                  otherwise collected by the Company by virtue of your use of
                  the Network) in machine-readable format to you or to a third
                  party when the Company justifies our processing on the basis
                  of your consent or the performance of a contract with you;
                </li>

                <li>
                  to withdraw your consent to the Company’s processing of your
                  personal data (where that processing is based on your
                  consent);
                </li>
                <li>
                  to obtain, or see a copy of the appropriate safeguards under
                  which your personal data is transferred to a third country or
                  international organization;
                </li>

                <li>
                  to object, at any time, to the processing of your personal
                  information, on legitimate grounds, except if otherwise
                  permitted by applicable law;
                </li>

                <li>
                  to erase your personal data (in limited circumstances, such as
                  where it is no longer necessary in relation to the purposes
                  for which it was collected or processed); and
                </li>
                <li>
                  to file a complaint with your local supervisory authority for
                  data protection.
                </li>
              </ul>
            </p>
            <p>
              You can exercise the above rights by sending email to
              connect@growlytics.in. If you establish a membership account with
              the Network, you may make changes to the Required Contact
              Information by accessing your account settings.
            </p>
            <p>
              Please note that if you ask the Company to stop processing your
              personal data in a certain way or erase your personal data, and
              this type of processing or data is needed to facilitate your use
              of the Network you may not be able to use the Network as you did
              before, or at all. This does not include your right to object to
              direct marketing, which can be exercised at any time without
              restriction. Please allow at least five (5) working days for your
              request to be addressed.
            </p>
            <p>
              Please note that the rights mentioned above do not extend to
              non-personal data. Please also note that it may be necessary to
              retain your personal data for the purposes of assessing and
              verifying data that is submitted to and/or held on the Network,
              and to manage the Network; your rights under applicable law may be
              limited accordingly.
            </p>

            <div className="content-header">Security</div>
            <p>
              The Company takes precautions, including administrative,
              technical, and physical measures – to help safeguard Data About
              Customers and other data transmitted to or from the Network
              against loss, theft, and misuse, as well as unauthorized access,
              disclosure, alteration, and destruction. No data transmissions
              over the internet, however, are guaranteed to be completely
              secure. While the Company strives to protect your data from
              unauthorized use or disclosure, the Company does not warrant or
              guarantee the security of the data that you provide to the
              Company; any transmission is at your own risk.
            </p>
            <p>
              Customers are solely responsible for protecting their user names,
              passwords, biometrics or other forms of authentication, limiting
              access to their computers, and signing out of the Services after
              their sessions. In order to protect you and your data, the Company
              may suspend your use of the Network without notice, pending an
              investigation, if any breach of security is suspected.
            </p>
            <p>
              The Company will notify Customer, as soon as possible, if a breach
              in security results in an unauthorized intrusion into Company’s
              system which materially affects Customer or people on Customer’s
              databases, and will subsequently report the corrective action
              taken in response to the intrusion.
            </p>

            <div className="content-header">
              Information Choices and Changes
            </div>
            <p>
              You may request to review, correct, delete or otherwise modify
              information you have previously provided to the Company through
              the Network. You have the right to ask the Company not to collect,
              use, process or disclose information about you in any of the
              manners described herein. This will affect your user experience.
              You can notify the Company of your intention to halt the
              collection, use, processing, or disclosure of your Required
              Contact Information at any time by contacting the Company at
              connect@growlytics.in.
            </p>
            <p>
              Some personal information is automatically collected via the use
              of data analytics tools. If you object to such collection, your
              only choice is not to access the Network.
            </p>

            <div className="content-header">Cookies</div>
            <p>
              Cookies are text files that web browsers place on a computer’s
              hard drive to tell site owners whether an individual has
              interacted with the website previously. The Company uses cookies
              to recognize repeat visits by users of the Network and to collect
              information about users’ interactions with and within the Network.
              The cookie may transmit information via your browser with a
              purpose of authenticating or identifying the computer (via e.g.,
              the IP address) or the user. The use of cookies enables the
              Company to make your experience with the Network easier and more
              meaningful.
            </p>
            <p>
              There are two types of cookies: session-based cookies and
              persistent-based cookies. Session cookies exist only during an
              online session. They disappear from your computer when you close
              your browser software or turn off your computer. Persistent
              cookies remain on your computer after you have closed your browser
              or turned off your computer. They include such information as a
              unique identifier for your browser. Standing alone, cookies do not
              contain personal data, and therefore do not identify you
              personally; they merely recognize your browser. Also, the Company
              may use other standard technologies including, but not limited to,
              pixel tags and web beacons, to track visitors to the Network.
              These technologies also help the Company to gather information
              including, but not limited to, the number of visitors to the
              Network, how visitors arrived at the Network, and the pages those
              visitors accessed. This information also helps the Company to
              improve the appearance and content of the Network and enhances the
              functionality of Network resources. Unless you choose to identify
              yourself to the Company by using the Network, you will remain
              anonymous to the Company. You may delete cookies if you no longer
              wish to store them on your computer.
            </p>
            <p>
              From time to time, the Company may engage third parties to track
              and analyze non-personally identifiable usage and volume
              statistical information from visitors to the Network to help it
              administer the Network and improve its quality. Such third parties
              may use cookies to help track visitor behavior, including visitor
              responsiveness to online advertisements. Such cookies will not be
              used to associate individual Network visitors with any personal
              data. All data collected by such third parties on the Company’s
              behalf is used only to provide the Company with information on
              Network usage and will not be shared with any other third parties.
            </p>
            <p>
              The cookies the Company uses do not transmit personally
              identifiable information to it or to its service providers. You
              have the choice to opt-out of receiving cookies from both the
              Company and third parties which will prevent the Company and third
              parties from tracking information about the online advertisements
              that you visit. Please note that you still will have the ability
              to view the Company’s online advertisements even if you opt-out of
              receiving cookies or if you choose to disable cookies, you may
              still use the Network; however, you may have limited access to
              some areas of the Network.
            </p>
            <p>
              If you wish to opt out of receiving cookies from the Company,
              please contact connect@growlytics.in. To opt-out of receiving
              cookies from the Company’s third parties, please contact
              connect@growlytics.in.
            </p>
            <p>
              For more detailed information about cookies and how they can be
              managed and deleted, please visit www.allaboutcookies.org.
            </p>

            <div className="content-header">Changes to this Privacy Policy</div>
            <p>
              The Company reserves the right to change this Privacy Policy. The
              Company will provide notification of the material changes to this
              Privacy Statement through the Site and via e-mail if permission is
              given by Customer to be e-mailed at least thirty (30) days prior
              to the change taking effect. If you have any questions or concerns
              about the changes, please contact the Company at
              connect@growlytics.in.
            </p>

            <div className="content-header">Legal Basis for Processing</div>
            <p>
              The Company has lawful bases to collect, use and share Data About
              Customers and any personal data the Company receives from, collect
              or maintains about you. Lawful bases include your consent (as
              provided for in this Privacy Policy and the Terms), contract
              (where processing is necessary for the performance of a contract
              with you), and other legitimate interests including, but not
              limited to, where processing is necessary to:
              <ol className="list-disc ml-6 md:ml-10 mt-2">
                <li>comply with laws that apply to the Company;</li>
                <li>
                  protect the vital interests of a natural person, such as in an
                  emergency or to protect you or the Company from threats (such
                  as security threats or fraud);
                </li>
                <li>
                  enable the Company to administer its business, such as for
                  quality control and customer service;
                </li>
                <li>manage corporate transactions; and/or</li>
                <li>
                  understand and improve the Company’s business and customer
                  relationships generally.
                </li>
              </ol>
            </p>
            <p>
              Where the Company has a legal basis to use your personal data
              without consent, this Privacy Policy fulfills its duty to process
              personal data fairly and lawfully and in a manner that you would
              expect given the nature of the Company’s relationship with you, by
              giving you appropriate notice and explanation of the way in which
              your personal data will be used. Where consent is required for the
              Company’s use of your personal data as described above, you have
              the right to withdraw or decline your consent and cease your use
              of the Network.
            </p>

            <div className="content-header">Contact Details</div>
            <p>
              If you have any questions about this Privacy Policy, or if you
              want to report privacy abuse, please contact the Company at:
              Growlytics Technologies Pvt Ltd, Akshar Blue Chip IT Park,
              Growlytics Technologies Pvt Ltd, 3rd Floor, Near IBIS Hotel, MIDC
              Industrial Area, Turbhe, Navi Mumbai, Maharashtra 400705
              connect@growlytics.in
            </p>
          </div>
        </div>
      </div>

      <FooterSection></FooterSection>
    </main>
  );
};

export default IndexPage;
